export function getUuid(): string {
    // let d = new Date().getTime();
    // if (window.performance && typeof window.performance.now === 'function') {
    //     d += performance.now();
    // }
    // const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    //     /* tslint:disable:no-bitwise */
    //     const r = (d + Math.random() * 16) % 16 | 0;
    //     d = Math.floor(d / 16);
    //     return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16).toUpperCase();
    //     /* tslint:enable:no-bitwise */
    // });
    // return uuid;
    return crypto.randomUUID().toUpperCase();
}

const urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
export function getRandomId(size = 21) {
    let id = '';
    const bytes = crypto.getRandomValues(new Uint8Array((size |= 0)));
    while (size--) {
        id += urlAlphabet[bytes[size] & 63];
    }
    return id;
}
